import type { Template } from "@/types";

export const PO_07_H1_V6: Template[] = [
    {
        id: "po-07-h1v6-01",
        name: "PO 01 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 31, y: 247, width: 625, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 719, y: 148, width: 203, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 719, y: 463, width: 203, height: 306, rotation: 0, imageRotation: 0 },
            { id: "4", x: 930, y: 148, width: 203, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 930, y: 463, width: 203, height: 306, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1141, y: 148, width: 202, height: 307, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1141, y: 463, width: 202, height: 306, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-02",
        name: "PO 02 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 48, y: 167, width: 585, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 544, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 197, y: 544, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 345, y: 544, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 493, y: 544, width: 140, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 738, y: 237, width: 289, height: 442, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 237, width: 288, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-03",
        name: "PO 03 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 125, y: 125, width: 458, height: 318, rotation: 0, imageRotation: 0 },
            { id: "2", x: 125, y: 451, width: 216, height: 340, rotation: 0, imageRotation: 0 },
            { id: "3", x: 349, y: 451, width: 234, height: 340, rotation: 0, imageRotation: 0 },
            { id: "4", x: 737, y: 125, width: 427, height: 665, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1172, y: 125, width: 151, height: 217, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1172, y: 350, width: 151, height: 216, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1172, y: 574, width: 151, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-04",
        name: "PO 04 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 149, y: 173, width: 191, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 173, width: 190, height: 281, rotation: 0, imageRotation: 0 },
            { id: "3", x: 149, y: 462, width: 191, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 462, width: 190, height: 281, rotation: 0, imageRotation: 0 },
            { id: "5", x: 733, y: 173, width: 309, height: 570, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1050, y: 173, width: 274, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1050, y: 366, width: 274, height: 377, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-05",
        name: "PO 05 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 49, y: 259, width: 588, height: 398, rotation: 0, imageRotation: 0 },
            { id: "2", x: 770, y: 114, width: 169, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 770, y: 346, width: 169, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 770, y: 578, width: 169, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 947, y: 114, width: 168, height: 224, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1123, y: 114, width: 168, height: 224, rotation: 0, imageRotation: 0 },
            { id: "7", x: 947, y: 346, width: 344, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-06",
        name: "PO 06 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 125, width: 581, height: 378, rotation: 0, imageRotation: 0 },
            { id: "2", x: 53, y: 511, width: 189, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 511, width: 189, height: 280, rotation: 0, imageRotation: 0 },
            { id: "4", x: 447, y: 511, width: 188, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 738, y: 156, width: 388, height: 574, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1134, y: 156, width: 190, height: 283, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1134, y: 447, width: 190, height: 283, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h1v6-07",
        name: "PO 07 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 133, y: 54, width: 271, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 133, y: 462, width: 271, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 54, width: 271, height: 400, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 54, width: 271, height: 400, rotation: 0, imageRotation: 0 },
            { id: "5", x: 970, y: 54, width: 271, height: 400, rotation: 0, imageRotation: 0 },
            { id: "6", x: 970, y: 462, width: 271, height: 400, rotation: 0, imageRotation: 0 },
            { id: "7", x: 412, y: 462, width: 550, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-08",
        name: "PO 08 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 178, width: 175, height: 276, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 175, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 183, y: 178, width: 175, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 183, y: 462, width: 175, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 366, y: 178, width: 174, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 366, y: 462, width: 174, height: 276, rotation: 0, imageRotation: 0 },
            { id: "7", x: 548, y: 178, width: 828, height: 560, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-07-h1v6-09",
        name: "PO 09 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 632, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 751, y: 193, width: 559, height: 364, rotation: 0, imageRotation: 0 },
            { id: "3", x: 751, y: 565, width: 106, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 565, width: 106, height: 158, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 565, width: 105, height: 158, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1092, y: 565, width: 105, height: 158, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1205, y: 565, width: 105, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h1v6-10",
        name: "PO 10 - H1V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h1_v6_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 573, width: 146, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 59, y: 349, width: 146, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 59, y: 126, width: 146, height: 215, rotation: 0, imageRotation: 0 },
            { id: "4", x: 213, y: 126, width: 946, height: 663, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1167, y: 573, width: 148, height: 216, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1167, y: 349, width: 148, height: 216, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1167, y: 126, width: 148, height: 215, rotation: 0, imageRotation: 0 }
        ],
    },

  

];
